import { Tab } from "@headlessui/react";
import PropTypes from "prop-types";

import ButtonNew from "components/atoms/ButtonNew/index";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import TabListNew from "components/molecules/TabListNew";

import styles from "./Index.module.scss";

const ToolCard = ({ data, ...props }) => {
  return (
    <div className={props?.className}>
      <div className={`${styles.toolCard} `}>
        <div>
          <Img
            className="w-full object-fill"
            wrapper={{ className: styles.toolImg }}
            {...data?.image}
          />
          <Title
            text={data?.name}
            as="h3"
            className={`text-lg font-semibold leading-7 text-bbc-brand-700 line-clamp-2 ${
              data?.description ? "mb-10" : ""
            }`}
          />
          {data?.description && (
            <p className="mb-6 px-0 text-left text-black lg:px-4 lg:text-center">
              {data.description}
            </p>
          )}
        </div>
        <ButtonNew
          as="a"
          useRouter
          href={data?.url}
          othersClass="uppercase mb-0 lg:mb-6"
        >
          Try now
        </ButtonNew>
      </div>
    </div>
  );
};

const ToolPanel = ({ listContent, contentClassName, ...props }) => {
  return (
    <div {...props}>
      {listContent && listContent.length > 0 ? (
        listContent.map((item, itemIdx) => (
          <ToolCard key={itemIdx} data={item} className={contentClassName} />
        ))
      ) : (
        <></>
      )}
    </div>
  );
};

const ToolTabList = ({ dataList, ...props }) => {
  return (
    <>
      <div className={`text-center ${props.className ? props.className : ""}`}>
        <TabListNew
          data={dataList.map((item) => item.name)}
          activeTab={
            dataList.findIndex((item) => item.isActive === true) === -1
              ? 0
              : dataList.findIndex((item) => item.isActive === true)
          }
          tabListClass={{
            border: "border-0",
            othersClass: "mb-10",
          }}
          tabClass={{
            padding: "px-4 py-1 lg:p-3",
            othersClass: "lg:mx-1",
          }}
        >
          <Tab.Panels>
            {dataList.map((item, index) => (
              <Tab.Panel
                className="focus:outline-0 focus:ring-0"
                as="div"
                key={index}
              >
                <div className="mx-auto lg:col-10">
                  <ToolPanel
                    listContent={item.tools}
                    className="flex space-x-6 overflow-x-auto lg:row lg:space-x-0"
                    contentClassName="lg:col-6 mb-10"
                  />
                </div>
              </Tab.Panel>
            ))}
          </Tab.Panels>
        </TabListNew>
      </div>
    </>
  );
};

export default ToolTabList;

ToolTabList.propTypes = {
  dataList: PropTypes.array,
};

ToolTabList.defaultProps = {
  data: [],
};
